import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject } from 'rxjs';
import { TokenService } from './token.service';
import { EncryptService } from './encrypt.service';
import { ToastrService } from 'ngx-toastr';
import { SessionStorageService } from '@app/shared/services/session-storage.service';


@Injectable({
    providedIn: 'root'
    
})

export class CommonService {

    toastr: ToastrService;

    constructor(private storage: SessionStorageService){

    }
    //Get the roles of the current logged in user and check if it is admin
    async checkLoggedUserIsAdmin(currentUserId?: any) {
        return true;
    }
}